import styled from "styled-components";

const VisibleLink = styled.a`
    font-weight: bold;
    text-decoration: underline;

    &:hover {
        text-decoration: underline;
    }
`
export default VisibleLink